import Vue from "vue";
Vue.filter("shortName", (name) => {
  return name
    .split(" ")
    .filter((x, idx, arr) => idx === 0 || idx === arr.length - 1)
    .join(" ");
});
